module.exports = __webpack_public_path__ + "img/2_101.edfb249c.png";